module.exports = require('../dist/components/Type/NativeType');
